import { gettext } from '@eventbrite/i18n';
import React from 'react';

const NORMAL_IMG_URL =
    '//maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png';
const HDPI_IMG_URL =
    '//maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3_hdpi.png';

export interface PoweredByGoogleLogoProps {
    className?: string;
}
export const PoweredByGoogleLogo = ({
    className,
}: PoweredByGoogleLogoProps) => (
    <img
        className={`powered-by-google-logo ${className}`}
        src={NORMAL_IMG_URL}
        srcSet={`${HDPI_IMG_URL} 2x`}
        alt={gettext('powered by Google').toString()}
    />
);
